import { format, toDate, utcToZonedTime } from 'date-fns-tz';
import { DEFAULT_DASH } from '~/nasa_ui/constants';
import { CENTRAL_TIME_ZONE } from '~/nasa_ui/types';
/**
 * Returns a "central-zoned" date string.
 *
 * The display will assume that the date given is in UTC. If provided a date
 * string with an offset, it will follow the offset. If the date to be displayed
 * is already in central, pass false to the third parameter.
 *
 * @param date The date to display.
 * @param displayValue Default display value.
 * @param isUtc Is the date argument in UTC?
 * @returns A date string in the format `yyyy-MM-dd HH::mm` (24-hour time)
 */
export const dateTimeDisplay = (date, displayValue = DEFAULT_DASH, isUtc = true) => {
    if (!date) {
        return displayValue;
    }
    const zonedTime = isUtc ? utcToZonedTime(date, CENTRAL_TIME_ZONE) : toDate(date, { timeZone: CENTRAL_TIME_ZONE });
    return format(zonedTime, 'yyyy-MM-dd HH:mm');
};
export const dateTimeDisplayOptions = (options) => {
    return dateTimeDisplay(options.date, options.displayValue, options.isUtc).split(' ').join('<br/>');
};
/**
 * Returns a "central-zoned" date string.
 *
 * The display will assume that the date given is in UTC. If provided a date
 * string with an offset, it will follow the offset. If the date to be displayed
 * is already in central, pass false to the third parameter.
 *
 * @param date The date to display.
 * @param displayValue Default display value.
 * @param isUtc Is the date argument in UTC?
 * @returns A date string showing only the time in 24-hour format: `HH:mm`
 */
export const timeDisplay = (date, displayValue = DEFAULT_DASH, isUtc = true) => {
    if (!date) {
        return displayValue;
    }
    const zonedTime = isUtc ? utcToZonedTime(date, CENTRAL_TIME_ZONE) : toDate(date, { timeZone: CENTRAL_TIME_ZONE });
    return format(zonedTime, 'HH:mm');
};
